import {atom} from 'recoil';

export const isMobileState = atom({
    key: 'isMobileState',
    default: false
});